import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15 5.1L9 3 3 5.02v16.2l6-2.33 6 2.1 6-2.02V2.77L15 5.1zm0 13.79l-6-2.11V5.11l6 2.11v11.67z"
}), 'MapSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MapSharp.js
// module id = 4774
// module chunks = 2